import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serchSelect, tabulation } from "@/mixins/index";
import { productList, productDel } from "@/api/kamitaku/kamitaku";
import uploadImagetow from '@/components/uploadImagetow';
export default {
  name: "productIdUpload",
  components: {
    uploadImagetow: uploadImagetow
  },
  mixins: [serchSelect, tabulation],
  data: function data() {
    return {
      data_type: '',
      ids: [],
      tableData: []
    };
  },
  created: function created() {},
  methods: {
    search: function search() {
      this.ids = [];
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('idLabel'),
        prop: 'product_id'
      }, {
        label: this.$t('nameLabel'),
        prop: 'kind'
      }];
      var data = [{
        product_id: 'product_id',
        kind: 'product_name'
      }].concat(_toConsumableArray(this.tableData));
      this.$export.csv({
        columns: columns,
        data: data,
        noHeader: true,
        title: this.$route.meta.title
      });
    },
    getList: function getList() {
      var _this = this;

      this.reqLoading = true;
      productList({
        game_id: this.rawData.game_id
      }).then(function (res) {
        if (res.status == 200) {
          _this.tableData = res.data;

          _this.$nextTick(function () {
            _this.getTableRight();
          });
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    deleHandle: function deleHandle(dataList) {
      var _this2 = this;

      var ids = dataList.map(function (item) {
        return item.id;
      }).toString();
      this.$confirm(this.$t('confirmDeleteData'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                productDel({
                  id: ids
                }).then(function (res) {
                  if (res.status == 200) {
                    _this2.getList();

                    _this2.$message({
                      type: "success",
                      message: _this2.$t('operationSuccess')
                    });

                    _this2.ids = [];
                  }
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};